import {connect} from 'react-redux';
import {SingleSelect as Component} from '../SingleSelect';
import {cscqSubmit, cscqSelectOption} from '@learningblocks/exp-redux';

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    selectOption: (params) => {
      dispatch(cscqSelectOption(params));
    },
    submitAnswer: (id) => {
      dispatch(cscqSubmit(id));
    },
  };
}
export const SingleSelectRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
